import { Injectable } from "@angular/core";
import { SessionService } from "src/app/core/auth/session.service";
import { ApiService } from "src/app/core/http/api.service";

@Injectable({
    providedIn: "root"
})
export class CoorporateConfigService {
    PROJECT_NAME:string = '';
    SUPPORT_EMAIL: string = '';
    currentDomain =  `${window.location.protocol}//${window.location.host}`;
    constructor(private readonly api: ApiService, private readonly session: SessionService ){
        console.log("Init CoorporateConfigService", this.currentDomain);
        /**
         * In future versions if require data of specific operator need this param in getCoorporateData
         * @param currentDomain
         * 
         */
        this.api.getCoorporateData().subscribe({    
            next: (response) => {
                this.session.setItem('projectName', response.data.operator?.name ? response.data.operator.name: ' ');
                this.session.setItem('supportEmail', response.data.contactEmail ? response.data.contactEmail: ' ');
                this.PROJECT_NAME = response.data.operator?.name;
                this.SUPPORT_EMAIL = response.data.contactEmail;
            },
            error: (error) => {
              console.error(error);
            }
          });
    }

    get projectName(): string {
        return this.PROJECT_NAME;
    }

    get supportEmail(): string {
        return this.SUPPORT_EMAIL;
    }
}